import { render } from "./ProductOrderImageBasedDetail.vue?vue&type=template&id=baee1564&scoped=true&ts=true"
import script from "./ProductOrderImageBasedDetail.vue?vue&type=script&lang=ts"
export * from "./ProductOrderImageBasedDetail.vue?vue&type=script&lang=ts"

import "./ProductOrderImageBasedDetail.vue?vue&type=style&index=0&id=baee1564&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baee1564"]])

export default __exports__